import { white } from './colour'

export const elevation = {
  bg: {
    color: white,
  },
  border: {
    radius: '8px',
  },
  1: {
    box: {
      shadow: '0px 0px 12px rgba(22, 29, 80, 0.08)',
    },
  },
  2: {
    box: {
      shadow: '0px 4px 18px rgba(22, 29, 80, 0.08)',
    },
  },
  3: {
    box: {
      shadow: '0px 4px 24px rgba(22, 29, 80, 0.12)',
    },
  },
  4: {
    box: {
      shadow: '0px 6px 24px rgba(22, 29, 80, 0.16)',
    },
  },
  5: {
    box: {
      shadow: '0px 0px 24px 2px rgba(22, 29, 80, 0.18)',
    },
  },
}
